import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=7637ef59&scoped=true&"
import script from "./Route.vue?vue&type=script&lang=ts&"
export * from "./Route.vue?vue&type=script&lang=ts&"
import style0 from "./Route.vue?vue&type=style&index=0&id=7637ef59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637ef59",
  null
  
)

export default component.exports